// Angular
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
// RxJS
import {catchError} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable()
export class InterceptService implements HttpInterceptor {

  constructor(private router: Router) {
  }

  // intercept request and add token
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token: string = localStorage.getItem('token');

    let request = req;
    const urlCloudFlare = 'https://www.cloudflare.com/cdn-cgi/trace';

    if (req.url !== (environment.url + 'auth') && req.url !== urlCloudFlare) {
      if (token) {
        request = req.clone({
          setHeaders: {
            Authorization: token
          }
        });
      }
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 || err.status === 403) {
          window.localStorage.removeItem('token');
          this.router.navigateByUrl('/auth/login');
        }

        return throwError(err);
      })
    );
  }
}
